function cov_2aocoezw6u() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Bedroom.tsx";
  var hash = "cf858b7856eda5b3c92ef60ef2c469556fb0dbf3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Bedroom.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 47
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "cf858b7856eda5b3c92ef60ef2c469556fb0dbf3"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2aocoezw6u = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2aocoezw6u();
var Icon = (cov_2aocoezw6u().s[0]++, {
  name: 'bedroom',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 2.25H3.25C6.65432 2.25 9.41406 5.00974 9.41406 8.41406V9.22266H16.1016C17.6659 9.22266 19.1662 9.8441 20.2724 10.9503C21.3786 12.0564 22 13.5567 22 15.1211V20.5C22 21.1904 21.4404 21.75 20.75 21.75C20.0596 21.75 19.5 21.1904 19.5 20.5V17.4668H4.5V20.5C4.5 21.1904 3.94036 21.75 3.25 21.75C2.55964 21.75 2 21.1904 2 20.5V2.25ZM4.5 14.9668H19.4965C19.4581 14.1216 19.1055 13.3189 18.5046 12.718C17.8673 12.0807 17.0029 11.7227 16.1016 11.7227H6.91406V8.41406C6.91406 6.82943 5.90813 5.47975 4.5 4.96875V14.9668Z\" fill=\"currentColor\"/>"
});
export default Icon;